var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 118,
    height: 118,
    viewBox: "0 0 118 118",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 118,
    height: 118,
    rx: 59,
    fill: "#CFEAE8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.2344 66.6789V38.0625C40.2344 37.5102 40.6821 37.0625 41.2344 37.0625H76.7638C77.3161 37.0625 77.7638 37.5102 77.7638 38.0625V66.6789C77.7638 70.2214 75.6856 73.4344 72.4547 74.8872L59.4092 80.7531C59.1484 80.8704 58.8498 80.8704 58.589 80.7531L45.5435 74.8872C42.3125 73.4344 40.2344 70.2214 40.2344 66.6789Z",
    stroke: "#408D86",
    strokeWidth: 4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50.4688 56.4688L56.4393 62.375L67.5276 49.7188",
    stroke: "#FF9723",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/Success.2a32397964921c0c0ed7c16b30aa49d7.svg";
export { ForwardRef as ReactComponent };